import { EuCountries, VendorCountry } from "../constants/AppConstants";
import { UserLoginState } from "../reducers/LoginReducer";

// function setMSLoginData(loggedUser: UserLoginState){
//     sessionStorage.setItem("MSloggedInUser", JSON.stringify(loggedUser));
// }

function setLoginUserData(loggedUser: UserLoginState) {
    localStorage.setItem("loggedInUser", JSON.stringify(loggedUser));
}

function setSapSystem(sapSystem: string) {
    localStorage.setItem("sapSystem", sapSystem);
}

function getSapSystem() {
    return localStorage.getItem("sapSystem");
}

function getLoginUserData() {
    return localStorage.getItem("loggedInUser");
}

function RefreshAccessToken(accessToken:string) {
    let loggedUser: UserLoginState = JSON.parse(Common.getLoginUserData()!);
    loggedUser.accessToken=accessToken;
    setLoginUserData(loggedUser);
}

function clearLocalStorage(){
    localStorage.removeItem("loggedInUser");
}

function isVendor() {
    let loggedUser: UserLoginState = JSON.parse(Common.getLoginUserData()!);
    if(loggedUser){
        return loggedUser.isVendor;
    }
    return false;
  }

function isEuCountry(country:string) {
    // return (
    //     country === NatureOfBusiness.PVTLimited ||
    //     country === NatureOfBusiness.Partnership ||
    //     country === NatureOfBusiness.Public ||
    //     country === NatureOfBusiness.Government
    //   );
    const values:string[] = Object.values(EuCountries);
    return values.includes(country);
}

function getLocalDateTime(dateText: string){
    let date = new Date(dateText);
    let timeZoneOffset = date.getTimezoneOffset();
    let localDate = new Date(date.getTime() - timeZoneOffset*60*1000);
    return localDate.toLocaleDateString() + ' ' + localDate.toLocaleTimeString();
}

export const Common = {
    //setMSLoginData,
    getLoginUserData,
    setLoginUserData,
    clearLocalStorage,
    RefreshAccessToken,
    isVendor,
    isEuCountry,
    getLocalDateTime,
    setSapSystem,
    getSapSystem
};


